import Cookies from 'js-cookie';

import { Defaults } from '../../constants';

import { refreshToken } from './TokenRefresher';

const API_URL = process.env.REACT_APP_BASE_URL || `https://api.ichitter.com/`;
const ACCESS_TOKEN_HEADER_KEY = 'Authorization';

export enum HttpMethod {
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export enum HttpStatusCode {
  OK = 200,
  CREATED = 201,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
}

export const StaticUrls = {
  REFRESH: API_URL + 'users/refresh',
};

export interface ApiParams {
  [key: string]: any;
}

export const setAccessToken = (accessToken: string, refreshToken: string) => {
  Cookies.set(Defaults.ACCESS_TOKEN_COOKIE_KEY, accessToken);
  Cookies.set(Defaults.REFRESH_TOKEN_COOKIE_KEY, refreshToken);
};

export const removeAccessToken = () => {
  Cookies.remove(Defaults.ACCESS_TOKEN_COOKIE_KEY);
  Cookies.remove(Defaults.REFRESH_TOKEN_COOKIE_KEY);
};

export async function apiHelper(method: string = HttpMethod.GET, path: string, params: ApiParams = {}) {
  const accessToken = Cookies.get(Defaults.ACCESS_TOKEN_COOKIE_KEY);

  const defaultOptions = {
    method,
    headers: {
      [ACCESS_TOKEN_HEADER_KEY]: 'Bearer ' + accessToken,
    },
  };

  let query;
  let requestOptions: any = {
    ...defaultOptions,
  };
  if (method === HttpMethod.GET || method === HttpMethod.DELETE) {
    query = Object.entries(params)
      .map(([paramKey, paramValue]) => `${encodeURIComponent(paramKey)}=${encodeURIComponent(paramValue)}`)
      .join('&');
  } else if (method === HttpMethod.PATCH || method === HttpMethod.POST || method === HttpMethod.PUT) {
    const headers = {
      ...defaultOptions.headers,
      'content-type': 'application/json',
    };
    requestOptions = {
      ...defaultOptions,
      headers,
      body: JSON.stringify(params),
    };
  }

  const apiUrl = API_URL;

  const urlPath = `${apiUrl}${path}`;
  const url = query ? `${urlPath}?${query}` : `${urlPath}`;

  let response = await fetch(url, requestOptions);
  let body;
  try {
    body = await response.json();
  } catch (error) {}
  if (response.status === HttpStatusCode.FORBIDDEN) {
    const refreshed = await refreshToken();
    if (refreshed) {
      requestOptions = {
        ...requestOptions,
        headers: {
          ...requestOptions.headers,
          [ACCESS_TOKEN_HEADER_KEY]: 'Bearer ' + Cookies.get(Defaults.ACCESS_TOKEN_COOKIE_KEY),
        },
      };
      response = await fetch(url, requestOptions);
      try {
        body = await response.json();
      } catch (error) {}
    }
  }
  return [response, body];
}

export const Api = {
  get(path: string, params?: ApiParams) {
    return apiHelper(HttpMethod.GET, path, params);
  },
  post(path: string, params?: ApiParams) {
    return apiHelper(HttpMethod.POST, path, params);
  },
  put(path: string, params?: ApiParams) {
    return apiHelper(HttpMethod.PUT, path, params);
  },
  patch(path: string, params?: ApiParams) {
    return apiHelper(HttpMethod.PATCH, path, params);
  },
  delete(path: string, params?: ApiParams) {
    return apiHelper(HttpMethod.DELETE, path, params);
  },
};

export default Api;
